export const groupLevels = {
    country: 'Country',
    svpTeam: 'SVP Team',
    group: 'Group',
    invalid: 'Invalid'
};
